import { BookOpenLight, DarhboardLight as DashboardIcon, PieChartLight } from '@profgeosoft-ui/icons';

import { IS_REPORT_AVAILABLE, LIBRARIES_URL } from 'src/api/consts';

export const navProps = [
  {
    name: 'Nav.dashboard',
    to: '/',
    isShown: true,
    renderIcon: (className: string) => <DashboardIcon className={className} />,
  },
  {
    name: 'Nav.libraries',
    to: LIBRARIES_URL,
    isExternalLink: true,
    isShown: true,
    renderIcon: (className: string) => <BookOpenLight className={className} />,
  },
  {
    name: 'Nav.report',
    to: '/report',
    isShown: IS_REPORT_AVAILABLE,
    renderIcon: (className: string) => <PieChartLight className={className} />,
  },
];
